export default __webpack_public_path__ + "static/media/osuosl.2c96fee8.png";